import type { TFunction } from "i18next";
import type { IWarehouseStaffRole, IWarehouseStaffScope } from "@/apis/warehouseStaff";

export type IRoleMeta = {
  code: IWarehouseStaffRole;
  color: string;
};

export const WAREHOUSE_STAFF_ROLES: IRoleMeta[] = [
  { code: "WAREHOUSE_KEEPER", color: "brand" },
  { code: "LOADING_KEEPER", color: "blue" },
  { code: "DELIVERY_SUPERVISOR", color: "violet" },
  { code: "DRIVER", color: "teal" },
];

export const WAREHOUSE_STAFF_SCOPES: { code: IWarehouseStaffScope }[] = [
  { code: "SINGLE" },
  { code: "MULTI" },
];

export const SUB_ROLE_CODES: IWarehouseStaffRole[] = [
  "LOADING_KEEPER",
  "DELIVERY_SUPERVISOR",
  "DRIVER",
];

export const getRoleMeta = (code: string): IRoleMeta | undefined =>
  WAREHOUSE_STAFF_ROLES.find((r) => r.code === code);

export const getRoleLabel = (t: TFunction, code: string): string =>
  t(`roles.${code}`, { defaultValue: code });

export const getScopeLabel = (t: TFunction, code: string): string =>
  t(`scopes.${code}`, { defaultValue: code });
